import { FC } from "react";

import CollectionTable from "./CollectionTable";

const Collection: FC = () => {
  return <CollectionTable />;
};

export default Collection;
